module.exports = __webpack_public_path__ + "static/media/star-favorite.c8b1ad20.svg";